<template>
  <div class="banner">
    <swiper :options="swiperOption" ref="videoSwiper" v-if="initOrNot">
      <swiper-slide v-for="(item, index) in mediaNews" :key="index">
        <img :src="item.url" class="multimedia" :class="{ 'zoom-animation': index === currentActiveIndex }" />
        <div class="w-100 position-absolute banner-maintitle-t30">
          <div class="m-auto container">
            <div class="lyd-text-1 " style="color: #152131;font-weight: 700;" v-html="item.title"></div>
            <!-- <div class="lyd-text-1 fw-bold text-black">提供智能服务的领导厂商</div> -->
            <div class="lyd-text-2" style="color: #445A77;font-weight: 400;" v-html="item.desc"></div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination lydswiper" v-for="(item, index) in mediaNews" :key="index" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "App",
  components: { swiper, swiperSlide },
  data() {
    return {
      mediaLastIndex: 0,
      currentActiveIndex: 0, // 新增：当前激活的slide索引
      swiperOption: {
        speed: 0,
        observer: true,
        observeParents: true,
        //effect : 'fade',
        //loop: true,
        autoplayDisableOnInteraction: true,
        // allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          paginationType: "bullets",
        },
        on: {
          slideChangeTransitionEnd: () => {
            this.slideChangeTransitionEndHandle();
          },
          slideChangeTransitionStart: () => {
            this.slideChangeTransitionStartHandle();
          },
          //控制第一个slide切换
          init: () => {
            this.initHandle();
          },
        },
      },
      initOrNot: false, //mediaNews数据改变的时候确保swiper会init一次
      mediaNews: [
        {
          url: require(`@/assets/newImages/home/home_banner3@2x.png`),
          type: 2,
          title: '博信城AI</br>成为企业增长与生命健康的精准引擎',
          desc: '盈利增速',
        },
        {
          url: require(`@/assets/newImages/home/home_banner1@2x.png`),
          type: 2,
          title: '为企业和公共组织</br>提供智能服务的领导厂商',
          desc: '赋能业务增长、成就企业梦想',
        },
        {
          url: require(`@/assets/newImages/home/home_banner2@2x.png`),
          type: 2,
          title: '元生AI平台',
          desc: '让企业管理更智能',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
      );
      return flag;
    },
    initHandle() {
      let that = this;
      setTimeout(function () {
        console.log(that.$refs.videoSwiper);
        let swiper = that.$refs.videoSwiper.swiper;
        that.currentActiveIndex = swiper.activeIndex; // 更新当前激活索引
        if (that.mediaNews[0]?.type === 2) {
          that.mediaNewsImgHandle(swiper);
        } else {
          document.getElementsByClassName("videoplay")[0]?.play();
        }
      }, 200);
    },
    slideChangeTransitionStartHandle() {
      let swiper = this.$refs.videoSwiper.swiper;
      this.currentActiveIndex = swiper.activeIndex; // 更新当前激活索引
      if (this.mediaNews[this.mediaLastIndex].type === 1) {
        document.getElementsByClassName("videoplay")[this.mediaLastIndex].currentTime = 0;
      } else {
      }
    },
    slideChangeTransitionEndHandle() {
      // console.log('end..')
      let that = this;
      let swiper = that.$refs.videoSwiper.swiper;
      this.currentActiveIndex = swiper.activeIndex; // 更新当前激活索引
      if (this.mediaNews[this.mediaLastIndex].type === 1) {
        document.getElementsByClassName("videoplay")[this.mediaLastIndex].pause();
      }
      if (this.mediaNews[swiper.activeIndex].type === 2) {
        this.mediaNewsImgHandle(swiper);
      } else {
        document.getElementsByClassName("videoplay")[swiper.activeIndex].play();
      }

      this.mediaLastIndex = swiper.activeIndex;
    },
    mediaNewsImgHandle(swiper) {
      let that = this;
      //刚切换到的activeIndex
      let changePointActiveIndex = swiper.activeIndex;
      if (swiper.activeIndex < this.mediaNews.length - 1) {
        setTimeout(function () {
          //要确认changePointActiveIndex是不是还是目前的activeIndex，是的话计时后执行，不是的话不执行
          if (changePointActiveIndex === swiper.activeIndex) {
            swiper.slideNext();
          }
        }, 3000);
      } else {
        setTimeout(function () {
          if (changePointActiveIndex === swiper.activeIndex) {
            swiper.slideTo(0, 0);
          }
        }, 3000);
      }
    },
    endVideo(index) {
      let swiper = this.$refs.videoSwiper.swiper;
      if (index === swiper.activeIndex) {
        if (swiper.activeIndex < this.mediaNews.length - 1) {
          swiper.slideNext();
          if (this.mediaNews[swiper.activeIndex].type === 1) {
            document.getElementsByClassName("videoplay")[swiper.activeIndex].play();
          } else {
            this.mediaNewsImgHandle(swiper);
          }
        } else {
          swiper.slideTo(0, 0);
          if (this.mediaNews[swiper.activeIndex].type === 1) {
            document.getElementsByClassName("videoplay")[swiper.activeIndex].play();
          } else {
            this.mediaNewsImgHandle(swiper);
          }
        }
      }
    },
  },
  watch: {
    mediaNews: {
      handler(newName, oldName) {
        this.initOrNot = false;
        this.$nextTick(() => {
          this.initOrNot = true;
        });
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.swiper-container {
  height: 100%;
}

.banner {
  width: 100%;
  height: 100%;

  .multimedia {
    width: 100%;
    height: 100%;
    transform: scale(1);
    transition: transform 0.3s ease-out;

    // 缓慢放大动画
    &.zoom-animation {
      animation: slowZoom 15s ease-out forwards;
    }
  }

  // 定义缓慢放大的关键帧动画
  @keyframes slowZoom {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.15);
    }
  }

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  //所有控件
  video::-webkit-media-controls-enclosure {
    display: none;
  }

  .banner-maintitle-t30 {
    top: 35%;
  }

  .banner-maintitle-t50 {
    top: 50%;
  }
  .swiper-pagination-clickable {
    display: block;
  }
  .swiper-pagination-bullet {
    width: 48px !important;
    height: 5px !important;
    border-radius: 2px !important;
    margin-right: 10px !important;
    background-color: #1571ec !important;
  }

  .swiper-pagination-clickable .swiper-pagination-bullet-active {
    width: 48px !important;
    height: 5px !important;
    background-color: #1571ec !important;
    border: 0;
  }

  .lydswiper {
    position: absolute;
  }
}
</style>
